export default __webpack_public_path__ + "static/media/default-profile.b165847e.svg";